module.exports = __webpack_public_path__ + "media/images/redesign-images/collegiate-new/design-tile-images/design-tile-09-5e8eb31acc5e35cd54b146817462e6d4.jpg";